import { ButtonProps, DialogProps } from '@mui/material';
import { UseMutationResult } from '@tanstack/react-query';
import { createContext } from 'react';
export type openDialogProps = {
    title?: string;
    message?: string;
    content?: React.ReactNode;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm?: () => any;
    confirmMutation?: UseMutationResult<unknown, Error, void, unknown>;
    confirmButtonProps?: ButtonProps;
    dialogProps?: Omit<DialogProps, 'open' | 'onClose'>;
    disableActions?: boolean;
};

interface DialogContextType {
    open: (props: openDialogProps) => void;
    close: () => void;
}

const DialogContext = createContext<DialogContextType>({
    open: () => {},
    close: () => {},
});

export default DialogContext;
